<template>
  <svg
    :class="customStyle"
    viewBox="0 0 40 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="20"
      cy="20.5"
      r="20"
      fill="white"
    />
    <path
      d="M20.5252 18.2458C21.0547 18.4986 21.5158 18.8747 21.8697 19.3427C22.2237 19.8107 22.4602 20.3567 22.5593 20.935C22.6585 21.5133 22.6174 22.107 22.4395 22.6661C22.2617 23.2253 21.9522 23.7335 21.5372 24.1483L17.8705 27.815C17.1829 28.5026 16.2502 28.8889 15.2778 28.8889C14.3053 28.8889 13.3727 28.5026 12.685 27.815C11.9974 27.1273 11.6111 26.1947 11.6111 25.2222C11.6111 24.2497 11.9974 23.3171 12.685 22.6295L14.1167 21.1978M24.9944 20.691L26.4261 19.2594C27.1137 18.5718 27.5 17.6391 27.5 16.6667C27.5 15.6942 27.1137 14.7616 26.4261 14.0739C25.7384 13.3863 24.8058 13 23.8333 13C22.8609 13 21.9282 13.3863 21.2406 14.0739L17.5739 17.7406C17.1589 18.1553 16.8494 18.6636 16.6716 19.2228C16.4937 19.7819 16.4526 20.3755 16.5518 20.9538C16.6509 21.5321 16.8874 22.0782 17.2414 22.5462C17.5953 23.0141 18.0564 23.3903 18.5859 23.6431"
      stroke="#218579"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'LinkIcon',

  props: {
    customStyle: {
      type: String,
      default: 'h-5 w-5',
    },
  },
}
</script>
